/* assets/lr-product.js — comportement de la fiche produit Lou Renard (<lr-product>). */
(function () {
  if (customElements.get('lr-product')) return;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || ('{' + '{amount_with_comma_separator}' + '} €');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function group(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return parts.join(sep);
    }
    var v = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': v = group(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = group(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = group(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = group(cents, 2, ' ', ','); break;
      default: v = group(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }

  class LrProduct extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.variants = JSON.parse(this.querySelector('[data-lr-variants]').textContent);
      this.moneyFormat = JSON.parse(this.querySelector('[data-lr-money]').textContent);
      this.motifIndex = parseInt(this.dataset.motifIndex, 10);
      this.packValue = this.dataset.packValue || '';
      this.determined = this.dataset.determined === 'true';
      this.threshold = parseFloat(this.dataset.threshold) || 0;
      this.pairEvery = parseInt(this.dataset.pairEvery, 10) || 0;
      this.idInput = this.querySelector('[data-lr-id]');
      this.qtyInput = this.querySelector('[data-lr-qty-input]');
      this.track = this.querySelector('[data-lr-track]');
      this.cart = { total_price: 0, item_count: 0 };
      this.lastSingle = null;

      var current = this.variantById(parseInt(this.idInput.value, 10)) || this.variants[0];
      this.selected = current.options.slice();
      if (this.motifIndex > -1 && current.options[this.motifIndex] !== this.packValue) this.lastSingle = current.options[this.motifIndex];

      this.querySelectorAll('[data-lr-option]').forEach(function (el) {
        if (el.type === 'radio') el.addEventListener('change', function () { self.setOption(parseInt(el.dataset.lrOption, 10), el.value, true); });
      });
      this.querySelectorAll('[data-lr-format]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.dataset.lrFormat === 'pack') self.setOption(self.motifIndex, self.packValue, true);
          else self.setOption(self.motifIndex, self.lastSingle || self.firstSingleValue(), true);
        });
      });
      this.querySelectorAll('[data-lr-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = (parseInt(self.qtyInput.value, 10) || 1) + parseInt(b.dataset.lrQty, 10);
          self.qtyInput.value = Math.max(1, Math.min(99, q));
          self.render();
        });
      });
      this.qtyInput.addEventListener('change', function () { self.render(); });

      if (this.track) {
        this.track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { self.syncGallery(); }); }, { passive: true });
        this.querySelectorAll('[data-lr-thumb]').forEach(function (t) {
          t.addEventListener('click', function () { self.goTo(parseInt(t.dataset.lrThumb, 10)); });
        });
        this.querySelectorAll('[data-lr-gal]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = self.track.children.length;
            var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth)) + parseInt(b.dataset.lrGal, 10);
            self.goTo((i + n) % n);
          });
        });
      }

      this.form = this.querySelector('form.lr-form') || this.querySelector('form');
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
      var stickyAdd = this.querySelector('[data-lr-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function () { self.addToCart(); });

      this.onExternalSelect = function (e) {
        if (!e.detail) return;
        if (e.detail.pack) self.setOption(self.motifIndex, self.packValue, true);
        else if (e.detail.value) self.setOption(self.motifIndex, e.detail.value, true);
        self.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      document.addEventListener('lr:select-motif', this.onExternalSelect);

      this.querySelectorAll('[data-lr-open]').forEach(function (b) {
        var dlg = document.getElementById(b.dataset.lrOpen);
        if (!dlg || typeof dlg.showModal !== 'function') return;
        b.addEventListener('click', function () { dlg.showModal(); document.documentElement.style.overflow = 'hidden'; });
        dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        dlg.querySelectorAll('[data-lr-close]').forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
      });

      var sticky = this.querySelector('[data-lr-sticky]');
      var cta = this.querySelector('[data-lr-cta]');
      if (sticky && cta && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        this.io.observe(cta);
      }

      this.render(false);
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.cart = c; self.render(false); })
        .catch(function () {});
    }

    disconnectedCallback() {
      document.removeEventListener('lr:select-motif', this.onExternalSelect);
      if (this.io) this.io.disconnect();
    }

    variantById(id) { return this.variants.find(function (v) { return v.id === id; }); }
    firstSingleValue() {
      var self = this;
      var v = this.variants.find(function (x) { return x.available && x.options[self.motifIndex] !== self.packValue; }) ||
              this.variants.find(function (x) { return x.options[self.motifIndex] !== self.packValue; });
      return v ? v.options[this.motifIndex] : null;
    }
    findVariant() {
      var sel = this.selected, mi = this.motifIndex;
      if (this.determined && mi > -1) {
        var byMotif = this.variants.find(function (v) { return v.options[mi] === sel[mi]; });
        if (byMotif) { this.selected = byMotif.options.slice(); return byMotif; }
      }
      return this.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) ||
             this.variants.find(function (v) { return mi > -1 && v.options[mi] === sel[mi]; }) ||
             this.variants.find(function (v) { return v.options[0] === sel[0]; });
    }

    setOption(index, value, jump) {
      if (index < 0 || value == null) return;
      this.selected[index] = value;
      if (index === this.motifIndex && value !== this.packValue) this.lastSingle = value;
      var radios = this.querySelectorAll('[data-lr-option="' + index + '"]');
      radios.forEach(function (r) { if (r.type === 'radio') r.checked = (r.value === value); });
      this.render(jump);
    }

    goTo(i, instant) {
      if (!this.track || i == null) return;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }
    syncGallery() {
      if (!this.track) return;
      var i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
      var total = this.track.children.length;
      var c = this.querySelector('[data-lr-counter]');
      if (c) c.textContent = (i + 1) + ' / ' + total;
      this.querySelectorAll('[data-lr-thumb]').forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }

    money(c) { return formatMoney(c, this.moneyFormat); }

    render(jump) {
      var v = this.findVariant();
      if (!v) return;
      var q = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
      var isPack = this.packValue && this.motifIndex > -1 && v.options[this.motifIndex] === this.packValue;
      this.idInput.value = v.id;

      var set = function (sel, fn) { var el = this.querySelector(sel); if (el) fn(el); }.bind(this);
      var self = this;
      set('[data-lr-price]', function (el) { el.textContent = self.money(v.price); });
      var onSale = v.compare > v.price;
      set('[data-lr-compare]', function (el) { el.hidden = !onSale; el.textContent = onSale ? self.money(v.compare) : ''; });
      set('[data-lr-discount]', function (el) { el.hidden = !onSale; if (onSale) el.textContent = '−' + Math.round((1 - v.price / v.compare) * 100) + ' %'; });
      set('[data-lr-add]', function (el) { el.disabled = !v.available; });
      set('[data-lr-add-label]', function (el) { el.textContent = v.available ? 'Ajouter au panier · ' + self.money(v.price * q) : 'Épuisé'; });
      this.querySelectorAll('[data-lr-static]').forEach(function (el) {
        var val = el.querySelector('[data-lr-static-value]');
        if (val) val.textContent = v.options[parseInt(el.dataset.lrStatic, 10)] || '';
      });
      set('[data-lr-motif-name]', function (el) { el.textContent = isPack ? '' : (v.options[self.motifIndex] || ''); });
      // Les motifs restent visibles : le pack est proposé juste en dessous.
      set('[data-lr-pack-group]', function (el) { el.hidden = !isPack; });
      this.querySelectorAll('[data-lr-format]').forEach(function (b) {
        b.setAttribute('aria-pressed', (b.dataset.lrFormat === 'pack') === !!isPack ? 'true' : 'false');
      });
      set('[data-lr-sticky-line]', function (el) { el.textContent = v.title.replace('Default Title', '').replace(/ \/ .*$/, '') + ' · ' + self.money(v.price * q); });
      set('[data-lr-sticky-img]', function (el) { if (v.thumb) el.src = v.thumb; });
      if (!isPack && v.thumb) set('[data-lr-format-img]', function (el) { el.src = v.thumb; });

      // Paliers : livraison offerte + paire offerte (panier actuel + sélection)
      var selTotal = v.price * q;
      var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
      if (this.threshold > 0) {
        var goal = Math.round(this.threshold * 100 * rate);
        var sum = (this.cart.total_price || 0) + selTotal;
        var rest = goal - sum;
        set('[data-lr-ship-text]', function (el) {
          el.innerHTML = rest > 0 ? 'Plus que <strong>' + self.money(rest) + '</strong> pour la livraison offerte' : '<strong>Livraison offerte</strong> sur votre commande';
        });
        var pct = Math.max(0, Math.min(100, sum / goal * 100));
        set('[data-lr-ship-bar]', function (el) { el.style.width = pct + '%'; });
        set('[data-lr-ship]', function (el) { el.style.setProperty('--lr-p', pct + '%'); el.classList.toggle('is-done', pct >= 100); });
      }
      if (this.pairEvery > 0) {
        var every = this.pairEvery;
        var count = (this.cart.item_count || 0) + q;
        var inCycle = count % every === 0 ? every : count % every;
        var free = Math.floor(count / every);
        set('[data-lr-pair-meter]', function (el) { el.hidden = !!isPack; });
        this.querySelectorAll('[data-lr-pairs] i').forEach(function (el, k) { el.classList.toggle('is-on', k < inCycle); });
        set('[data-lr-pair-text]', function (el) {
          var gift = '<span class="lr-emoji" aria-hidden="true">🎁</span> ';
          if (count % every === 0) el.innerHTML = gift + '<strong>' + free + ' paire' + (free > 1 ? 's' : '') + ' offerte' + (free > 1 ? 's' : '') + '</strong> avec cette sélection';
          else { var left = every - (count % every); el.innerHTML = gift + 'Encore <strong>' + left + ' paire' + (left > 1 ? 's' : '') + '</strong> et la ' + every + '<sup>e</sup> est offerte'; }
        });
      }

      if (jump && v.media != null) this.goTo(v.media);
      if (jump && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }
    }

    toast(html) {
      var t = this.querySelector('[data-lr-toast]');
      if (!t) return;
      t.innerHTML = html;
      t.classList.add('is-on');
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
    }

    addToCart() {
      var self = this;
      var btn = this.querySelector('[data-lr-add]');
      var msg = this.querySelector('[data-lr-msg]');
      if (!btn || btn.disabled) return;
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      btn.disabled = true;
      msg.textContent = '';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(this.idInput.value, 10), quantity: Math.max(1, parseInt(this.qtyInput.value, 10) || 1) }] })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Erreur'); return d; }); })
        .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          self.cart = cart;
          self.qtyInput.value = 1;
          self.render(false);
          // Prévient le thème (icône panier + tiroir panier du thème Tinker / Horizon)
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: self.id, data: { source: 'lr-product', itemCount: cart.item_count, productId: self.dataset.section } }
          }));
          var drawer = document.querySelector('cart-drawer-component');
          if (self.dataset.openDrawer === 'true' && drawer && typeof drawer.open === 'function') {
            setTimeout(function () { drawer.open(); }, 250);
          } else {
            self.toast('Ajouté au panier ✓ <a href="' + root + 'cart">Voir le panier</a>');
          }
        })
        .catch(function (err) { msg.textContent = err.message || "Impossible d'ajouter ce produit au panier."; })
        .finally(function () { var v = self.findVariant(); btn.disabled = !(v && v.available); });
    }
  }
  customElements.define('lr-product', LrProduct);
})();
